import './AppHeader.scss';
import logo from '../../images/possibilit_logo.svg';
import arrowBarLeft from '../../images/arrow-bar-left.svg';
import arrowDegLeft from '../../images/arrow-deg-left.svg';
import verticalVector from '../../images/vertical-vector.svg';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { useIdentity } from '../../auth/useIdentity';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertBell } from '../Alerts/Alerts';

export const AppHeader = () => {
    const { isAuthenticated, logout } = useAuth();
    const { likelyAdmin } = useIdentity();
    const [isOnDetailPage] = useState<boolean>(true);

    const handleLogout = () => {
        logout({ returnTo: window.location.origin });
    };

    /*
        No Bootstrap row around the header.

        A .row has negative margins of 12px that cancel against the gutters of a surrounding
        .container. This one was not inside such a container, so the page ended up 24 pixels
        wider than the window and every screen in the app had a horizontal scrollbar.
    */
    return (
                    <header className="arl-header">
                        <div className="arl-header__logo">
                            <Link to={'/'}>
                                <img src={logo} alt="logo" />
                            </Link>
                        </div>
                        {isAuthenticated && (
                            <nav className="arl-header__nav">
                                <span className={'d-none'}> |{' '}</span>
                                <Link to="/topdesk" className={'d-none'}>topdesk</Link>
                            </nav>
                        )}

                        {isAuthenticated && (
                            <div className="arl-header__actions">
                                { isOnDetailPage &&
                                    <div className="arl-header__flex">
                                        <Link to="/dashboard" className='arl-header__dashboard-link'>
                                            <img src={arrowDegLeft} width={24} height={24} alt="arrow-90deg-left" />
                                            <span>Dashboard</span>
                                        </Link>
                                        <img src={verticalVector} width={24} height={24} alt="arrow-bar-left" />
                                    </div>
                                }
                                {likelyAdmin && <AlertBell />}
                                {/* The backlog spans every customer, so only admins get the way in. */}
                                { likelyAdmin &&
                                    <div className="arl-header__flex">
                                        <Link to="/issues" className='arl-header__dashboard-link'>
                                            <FontAwesomeIcon icon="inbox" />
                                            <span>Issues</span>
                                        </Link>
                                        <Link to="/rollout" className='arl-header__dashboard-link'>
                                            <FontAwesomeIcon icon="rocket" />
                                            <span>Uitrol</span>
                                        </Link>
                                        <img src={verticalVector} width={24} height={24} alt="arrow-bar-left" />
                                    </div>
                                }
                                <div
                                    onClick={handleLogout}
                                    className='arl-header__logout-link'
                                    aria-label="Log Out"
                                >
                                    <img src={arrowBarLeft} width={24} height={24} alt="arrow-bar-left" />
                                    <div>Logout</div>
                                </div>
                            </div>
                        )}
                    </header>
    );
};
